const HeaderUser = ({ dataUser }) => {
  // choose appropriate picture to preload
  return (
    <header className="header-users">
      <div className="header-users__title">
        <h1>{dataUser.header.title}</h1>
        <p>{dataUser.header.subtitle}</p>
      </div>
      <div className="header-users__picture">
        <picture>
          {dataUser.header.sources.map((source, idx) => (
            <source
              key={idx}
              media={source.media}
              sizes={source.sizes}
              srcSet={source.srcSet
                .map((item) => `${item.src} ${item.width}`)
                .join(", ")}
            />
          ))}
          <img
            src={dataUser.header.fallback}
            alt={dataUser.header.altImg}
            fetchpriority="high"
          />
        </picture>
      </div>
    </header>
  );
};

export default HeaderUser;
